module.exports = __webpack_public_path__ + "bradavice_6_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_6_before_tn.jpg
// module id = 1408
// module chunks = 0